import { AjaxError } from "rxjs/ajax";

export const parseServerError = <Err extends any>(error: AjaxError): any => {
  const validation_messages: Err = error?.response?.validation_messages;

  if (validation_messages) {
    return Object.entries(validation_messages).reduce((result, [key, error]) => {
      const value = typeof error === "string" ? error : Object.values(error).join(", ");

      return { ...result, [key]: value };
    }, {});
  }

  error?.stack && console.log(error?.stack);
  const detail: string = error?.response?.detail || error?.response?.message;
  return detail || "Unknown server error";
};

export function getMessageFromServerError(error: unknown, addPrefix = true): string | null {
  if (typeof error === "string") {
    return error;
  }

  const messages: Array<string> = [];
  if (typeof error !== "object" || error === null) {
    return null;
  }

  Object.entries(error).forEach(([fieldKey, fieldError]) => {
    const message = getMessageFromServerError(fieldError, false);
    if (!message) {
      return null;
    }

    if (addPrefix) {
      messages.push(`${fieldKey}: ${message}`);
    } else {
      messages.push(message);
    }
  });

  return messages.join(";\n\r");
}
